import { qpDatatables } from "../utils/misc";
import { push } from 'react-router-redux';
import { toast } from "react-toastify";
import axios from 'axios';

const actionTypes = {
    INVOICE_GETALL_REQUEST: 'INVOICE_GETALL_REQUEST',
    INVOICE_GETALL_RESPONSE: 'INVOICE_GETALL_RESPONSE',
    INVOICE_POST_CARD_PAY_REQUEST: 'INVOICE_POST_CARD_PAY_REQUEST',
    INVOICE_POST_CARD_PAY_RESPONSE: 'INVOICE_POST_CARD_PAY_RESPONSE',
};


export const requestInvoiceGetAll = (startDateIndex, pageType) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.INVOICE_GETALL_REQUEST, startDateIndex });
    const url = `api/Invoice/GetInvoiceData?startDateIndex=${startDateIndex}&pageType=${pageType}`;

    await fetch(url, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    })
        .then(handleResponse)
        .then(
            result => {
                dispatch({
                    type: actionTypes.INVOICE_GETALL_RESPONSE,
                    startDateIndex,
                    invoiceItems: result.invoiceList,
                    minaylaURL: result.minaylaUrl,
                    customerId: result.customerId,
                    isFactoringEnabled: result.isFactoringEnabled
                });

                qpDatatables();
            },
            error => {
                if (error.status === 401) {
                    dispatch(push('/login'));
                } else {
                    toast.warn("Error:" + error.error, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                }
            }
        );
}

export const makeCustomerCharge = (state) => async (dispatch, getState) => {
    dispatch({ type: actionTypes.INVOICE_POST_CARD_PAY_REQUEST, isLoading: true });
    const url = `api/Invoice/CreateCustomerPayment`;
    await axios({
        method: 'post',
        url: url,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        },
        data: JSON.stringify(state)
    }).then(result => {
        if (result.status === 200) {
            dispatch({ type: actionTypes.INVOICE_POST_CARD_PAY_RESPONSE, isLoading: false });
            toast.success('Payment Successfully Charged', {
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    });
}

export const actionCreators = {

};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return Promise.reject({ status: response.status });
            }
            const error = text;
            return Promise.reject({ status: response.status, error });
        }
        return data;
    });
}


// WEBPACK FOOTER //
// ./src/actions/InvoiceAction.js